import './checkbox.scss';

interface ICheckboxProps {
    onCheck: () => void;
    label: string;
    checked: boolean;
}

const Checkbox: React.FC<ICheckboxProps> = ({ onCheck, label, checked }) => {
    return (
        <label className="checkbox">
            <input className="checkbox__input" type={'checkbox'} onChange={onCheck} checked={checked} />
            {label}
            <span className="checkbox__checkmark"></span>
        </label>
    );
};

export default Checkbox;
